import React from 'react';
import PropTypes from 'prop-types';

import { ACTION_VIEW_MOD } from './translations';

import styles from './ActionViewMod.module.css';

export default class ActionViewMod extends React.PureComponent {
    static propTypes = {
        onClick: PropTypes.func,
    }

    render() {
        return (
            <div className={styles.base} onClick={this.props.onClick}>
                {ACTION_VIEW_MOD}
            </div>
        )
    }
}
